import { useState, useEffect } from 'react';
import GalleryContext from './GalleryContext';

import { urlJson } from '../Constants';
import axios from 'axios';

const GalleryProvider = ({ children }) => {
    
    const [loading, setLoading] = useState(true);
    const [dataGallery, setDataGallery] = useState([]);

    const getGalleryData = async () => {
        try{
            const result = await axios(urlJson);
            setDataGallery(result.data);
            setLoading(false);
        }
        catch(error){
            console.log('Error al obtener los datos: ',error);
        }            
    } 
    
    useEffect(() => {
        getGalleryData(); 
    }, []);

    return (
        <GalleryContext.Provider value={{ dataGallery, loading }} >
            { children }
        </GalleryContext.Provider>
    )
}

export default GalleryProvider
